(function () {
  'use strict';

  /* ==========================================
     CONFIG
  ========================================== */

  const MIN_CART_VALUE = 3000;
  const MIN_CART_VALUE_PAISE = MIN_CART_VALUE * 100;

  // Native Shopify main cart
  const MAIN_CHECKOUT_SELECTOR = '.cart__checkout-button';

  // Breeze cart drawer
  const BREEZE_CART_SELECTOR = 'breeze-cart';
  const BREEZE_CHECKOUT_SELECTOR = '.checkout-button';

  const MESSAGE_CLASS = 'minimum-cart-checkout-message';

  let cartTotal = null;
  let breezeRoot = null;
  let refreshTimer = null;
  let isFetchingCart = false;


  /* ==========================================
     GET SHOPIFY CART
  ========================================== */

  async function refreshCart() {
    if (isFetchingCart) return;
    isFetchingCart = true;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const cart = await response.json();
      cartTotal = cart.total_price;

      updateMainCheckout();
      setupBreezeDrawer();
      updateBreezeCheckout();

    } catch (error) {
      // Silent catch in production to avoid console clutter
    } finally {
      isFetchingCart = false;
    }
  }


  /* ==========================================
     DEBOUNCED REFRESH
  ========================================== */

  function scheduleCartRefresh(delay = 300) {
    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(function () {
      refreshCart();
    }, delay);
  }


  /* ==========================================
     MESSAGE
  ========================================== */

  function addMessage(button) {
    if (!button || !button.parentNode) return;

    const parent = button.parentNode;

    if (parent.querySelector(`.${MESSAGE_CLASS}`)) {
      return;
    }

    const message = document.createElement('div');
    message.className = MESSAGE_CLASS;

    message.innerHTML = `
      <span style="
        margin-right: 6px;
        font-size: 13px;
      ">ⓘ</span>

      <span>
        Minimum order value is <strong>₹3,000</strong>
      </span>
    `;

    // Layout
    message.style.width = '100%';
    message.style.flexBasis = '100%';
    message.style.boxSizing = 'border-box';

    message.style.display = 'flex';
    message.style.alignItems = 'center';
    message.style.justifyContent = 'center';

    // Spacing
    message.style.margin = '0 0 10px 0';
    message.style.padding = '8px 12px';

    // Light red background
    message.style.background = '#FFF1F1';

    // Red text
    message.style.color = '#C62828';

    // Subtle red border
    message.style.border = '1px solid #FFD2D2';
    message.style.borderRadius = '6px';

    // Typography
    message.style.fontSize = '12px';
    message.style.fontWeight = '500';
    message.style.lineHeight = '16px';
    message.style.whiteSpace = 'nowrap';

    // Slight depth
    message.style.boxShadow = '0 1px 3px rgba(198, 40, 40, 0.08)';

    if (getComputedStyle(parent).display === 'flex') {
      parent.style.flexWrap = 'wrap';
    }

    parent.insertBefore(message, button);
  }

  function removeMessage(button) {
    if (!button || !button.parentNode) return;

    const message = button.parentNode.querySelector(`.${MESSAGE_CLASS}`);

    if (message) {
      message.remove();
    }
  }


  /* ==========================================
     COMMON BUTTON STATE
  ========================================== */

  function disableCheckout(button) {
    if (!button) return;

    button.disabled = true;
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('data-min-cart-disabled', 'true');

    button.style.opacity = '0.5';
    button.style.cursor = 'not-allowed';

    addMessage(button);
  }


  function enableCheckout(button) {
    if (!button) return;

    button.disabled = false;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('data-min-cart-disabled');

    button.style.opacity = '';
    button.style.cursor = '';

    removeMessage(button);
  }


  function updateButtonState(button) {
    if (!button || cartTotal === null) {
      return;
    }

    if (cartTotal < MIN_CART_VALUE_PAISE) {
      disableCheckout(button);
    } else {
      enableCheckout(button);
    }
  }


  /* ==========================================
     MAIN CART
     .cart__checkout-button
  ========================================== */

  function updateMainCheckout() {
    const buttons = document.querySelectorAll(MAIN_CHECKOUT_SELECTOR);

    buttons.forEach(function (button) {
      updateButtonState(button);
    });
  }


  /* ==========================================
     MAIN CART CLICK BLOCKER
  ========================================== */

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(MAIN_CHECKOUT_SELECTOR);

      if (!button) return;

      if (cartTotal !== null && cartTotal < MIN_CART_VALUE_PAISE) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    },
    true
  );


  /* ==========================================
     MAIN CART FORM SUBMIT BLOCKER
  ========================================== */

  document.addEventListener(
    'submit',
    function (event) {
      const submitter = event.submitter;

      if (!submitter) return;

      if (
        submitter.matches(MAIN_CHECKOUT_SELECTOR) &&
        cartTotal !== null &&
        cartTotal < MIN_CART_VALUE_PAISE
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    },
    true
  );


  /* ==========================================
     BREEZE CART DRAWER
  ========================================== */

  function getBreezeRoot() {
    const breezeCart = document.querySelector(BREEZE_CART_SELECTOR);

    if (!breezeCart) {
      return null;
    }

    return breezeCart.shadowRoot || null;
  }


  function updateBreezeCheckout() {
    const root = getBreezeRoot();

    if (!root) {
      return;
    }

    breezeRoot = root;

    const buttons = root.querySelectorAll(BREEZE_CHECKOUT_SELECTOR);

    buttons.forEach(function (button) {
      updateButtonState(button);
    });
  }


  /* ==========================================
     BREEZE CLICK BLOCKER
  ========================================== */

  function attachBreezeClickBlocker(root) {
    if (root.__minimumCartClickHandler) {
      return;
    }

    root.__minimumCartClickHandler = true;

    root.addEventListener(
      'click',
      function (event) {
        const path = event.composedPath();

        const checkoutButton = path.find(function (element) {
          return (
            element &&
            element.matches &&
            element.matches(BREEZE_CHECKOUT_SELECTOR)
          );
        });

        if (!checkoutButton) {
          return;
        }

        if (cartTotal !== null && cartTotal < MIN_CART_VALUE_PAISE) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          disableCheckout(checkoutButton);
          return false;
        }
      },
      true
    );
  }


  /* ==========================================
     WATCH BREEZE SHADOW DOM
  ========================================== */

  function attachBreezeObserver(root) {
    if (root.__minimumCartObserver) {
      return;
    }

    let breezeMutationTimer;

    const observer = new MutationObserver(function () {
      clearTimeout(breezeMutationTimer);

      breezeMutationTimer = setTimeout(function () {
        updateBreezeCheckout();
      }, 50);
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });

    root.__minimumCartObserver = observer;
  }


  /* ==========================================
     SETUP BREEZE DRAWER
  ========================================== */

  function setupBreezeDrawer() {
    const root = getBreezeRoot();

    if (!root) {
      return;
    }

    breezeRoot = root;

    attachBreezeClickBlocker(root);
    attachBreezeObserver(root);
    updateBreezeCheckout();
  }


  /* ==========================================
     WATCH NORMAL DOM
  ========================================== */

  let mainMutationTimer;

  const mainObserver = new MutationObserver(function () {
    clearTimeout(mainMutationTimer);

    mainMutationTimer = setTimeout(function () {
      updateMainCheckout();
      setupBreezeDrawer();
    }, 100);
  });


  /* ==========================================
     WATCH SHOPIFY FETCH REQUESTS
  ========================================== */

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url || '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        scheduleCartRefresh(300);
      }
    } catch (error) {
      // Ignore URL parsing errors
    }

    return response;
  };


  /* ==========================================
     QUANTITY CHANGE FALLBACK
  ========================================== */

  document.addEventListener('change', function (event) {
    const target = event.target;

    if (target.matches('input[name="updates[]"], .quantity__input')) {
      scheduleCartRefresh(400);
    }
  });


  /* ==========================================
     INITIALIZE
  ========================================== */

  function init() {
    mainObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial cart check
    refreshCart();
    setupBreezeDrawer();

    // Gentle progressive retries for late-loading Breeze Web Components without infinite polling
    [300, 1000, 2500, 5000].forEach((delay) => {
      setTimeout(setupBreezeDrawer, delay);
    });

    // Refresh cart when user returns to tab
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        scheduleCartRefresh(100);
      }
    });

    window.addEventListener('focus', function () {
      scheduleCartRefresh(100);
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();